module.exports = __webpack_public_path__ + "static/media/7c8b9359.jpg";